import React from 'react'
import { useStateContext } from '../../context/ContextProvider'
import { useTranslation } from 'react-i18next'

const GradiantButton = ({text ,icon,textSize}) => {
  const {t}=useTranslation()
  const {currentMode}=useStateContext()
  return (
    <button className={`rounded-xl  flex-row items-center ${icon ? "gap-2 " : "  justify-center"}  ${currentMode === "Light" ?"gradiant_Light_Button " :"gradiant_Dark_Button" }`}>
      <span className={`creative-btn-text  font-kufi ${textSize}`}>{t(text)}</span>
  {icon&&    <span className=''>{icon}</span>}
      </button>
  )
}

export default GradiantButton